export default "__VITE_ASSET__CxLaDNdg__"